import type {
  ParameterOption,
  RevitCategory,
  WorkflowMode,
} from '../stores/useParameterWorkflowStore';

export const DEFAULT_PARAMETER_WORKFLOW_MODE: WorkflowMode = 'legacy';

export const DEFAULT_PARAMETER_WORKFLOW_SHARED_PARAMETER_FILE_PATH =
  'PipeEX_SharedParameters.txt';

export const DEFAULT_PARAMETER_WORKFLOW_SYSTEM_GROUPING = 'BySystemName';

export const PARAMETER_WORKFLOW_CATEGORY_OPTIONS = [
  'PIPES',
  'PIPE FITTINGS',
  'PIPE ACCESSORIES',
  'GENERIC MODELS',
  'MECHANICAL EQUIPMENT',
] as const satisfies readonly RevitCategory[];

export const DEFAULT_PARAMETER_WORKFLOW_PARAMETERS: ParameterOption[] = [
  {
    name: '#PCF_OBJECT_TYPE',
    selected: true,
    description: 'PCF object type — identifies the component type in PCF export.',
  },
  {
    name: '#PCF_SKEY',
    selected: true,
    description: 'PCF SKEY — identifies the component with a short key.',
  },
  {
    name: 'PiP_PPG_SPEC',
    selected: true,
    description: 'Piping specification — defines the piping specification code.',
  },
];

export const DEFAULT_PARAMETER_WORKFLOW_SELECTED_CATEGORIES: RevitCategory[] = [
  ...PARAMETER_WORKFLOW_CATEGORY_OPTIONS,
];
